<template>
  <div>
    <vxe-grid
      size="small"
      resizable
      auto-resize
      border
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableReData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="$emit('openEditPage', row.dfDefinitionItemCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:displayItemName="{ row }">
        <div>{{ row.itemName }}</div>
        <div>{{ row.itemNameEn }}</div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l("INDEX.table_label_no_data") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from "@/mixins/table-auto-height";
import EditLoading from "@/mixins/edit-loading";
import tableColumns from "./table-columns";
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    dfDefinitionCode: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: "toolbar_form" },
      },
      columns: [],
    };
  },
  computed: {
    tableColumns() {
      const c = tableColumns(this);
      const cm = this.columns.map((e) => {
        return {
          field: e.value,
          title: e.label,
          align: "center",
          width: 80,
          showHeaderOverflow: true,
        };
      });
      return [
        ...c,
        {
          title: this.$l("table_label_defect_severity") || "位置及疵点等级",
          align: "center",
          showHeaderOverflow: true,
          children: cm,
        },
      ];
    },
    tableReData() {
      return this.tableData.map((e) => {
        return {
          ...e,
          ...(e.itemValueMap || {}),
        };
      });
    },
  },
  mounted() {
    this.getColumn();
  },
  methods: {
    getColumn() {
      this.$api
        .dfsDfDefinitionItemColumnApi({
          dfDefinitionCode: this.dfDefinitionCode,
        })
        .then((res) => {
          if (res.status === 200) {
            this.columns = res?.body?.data || [];
          }
        });
    },
    async del({ dfDefinitionItemCode }) {
      const confirm = await this.$confirm(
        this.$l("tips_confirm_delete_defect_severity") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText: this.$l("INDEX.btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirm) return;
      if (this.loadingOpen()) return;

      const res = await this.$api
        .dfsDfDefinitionItemDelApi({ dfDefinitionItemCode })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;

      const { status } = res;
      if (status !== 200) {
        this.$message.error(this.$l("INDEX.tips_delete_no") || "删除失败！");
        return;
      }
      this.$message({
        message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
        type: "success",
      });
      this.$emit("reload");
    },
  },
};
</script>
